import { render } from "./Activity.vue?vue&type=template&id=f5ac35b0"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__